import React from 'react'
import DateFormat from '../../../../shared/helpers/date-format'

let { timeSimple, timeMeridian } = DateFormat

const TimeCell = ({ time }) => (
  <dt className="bg-black-4 text-depths text-18 xl:text-24 lg:m-1 p-16 pb-0 lg:p-20 lg:w-180-fixed">
    <span className="sr-only">At</span>

    <time className="font-bold">
      {timeSimple(time)}
      <span className="text-12">{timeMeridian(time)}</span>
    </time>
  </dt>
)

export default TimeCell
